import { render, staticRenderFns } from "./ModalItemOS.vue?vue&type=template&id=69963999&scoped=true"
import script from "./ModalItemOS.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalItemOS.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69963999",
  null
  
)

export default component.exports